var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',_vm._b({staticClass:"lang-multiselect",attrs:{"label":_vm.$t('components.select_language'),"placeholder":_vm.$t('components.select_language'),"type":"multi-select","variant":"alt","element-class":(context, classes) => ['flex-1 min-w-full'].concat(classes),"options":_vm.computedOptions,"searchable":"","show-icon":"","config":{
    label: _vm.labelKey,
    trackBy: _vm.idKey,
  },"validation":_vm.validation},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'FormulateInput',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }